import { REDUX_ACTIONS, GAME_ID } from 'a/directorsCut/data/constants';

const initState = {
  isDrag: false, // show if any item currently is being dragged
  isInDropZone: false, // show if any item currently is dropped into dropzone
  dragIndex: -1, // index of an item currently is being dragged
  dragId: '',
};

const dragReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.START_DRAG:
      return {
        ...state,
        isDrag: true,
        dragId: payload.id,
      };

    case REDUX_ACTIONS.STOP_DRAG:
      return {
        ...state,
        isDrag: false,
        dragIndex: -1,
        isInDropZone: false,
        dragId: '',
      };

    case REDUX_ACTIONS.SET_IS_IN_DROP_ZONE:
      return {
        ...state,
        isInDropZone: payload,
      };

    case REDUX_ACTIONS.SET_DRAG_INDEX:
      return {
        ...state,
        dragIndex: payload,
      };

    case REDUX_ACTIONS.NEXT_STANDARD_ITEM:
    case REDUX_ACTIONS.ROUND_END: {
      return {
        ...initState,
      };
    }

    default:
      return state;
  }
};

export default dragReducer;
